import { useCallback, useMemo } from 'react';
import { useHistory, useLocation } from 'react-router-dom';

const useSearchParams = () => {
  const { search } = useLocation();
  const history = useHistory();

  const searchParams = useMemo(() => new URLSearchParams(search), [search]);

  const syncSearchParams = useCallback(
    (_searchParams?: URLSearchParams) => {
      history.replace({ search: (_searchParams || searchParams).toString() });
    },
    [history, searchParams]
  );

  const size = useMemo(() => Array.from(searchParams.entries()).length, [searchParams]);

  return { searchParams, syncSearchParams, size };
};

export default useSearchParams;
